import { Component, computed, inject, input, signal } from '@angular/core';
import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import {
  InstallmentStatus,
  Order,
} from '../../../../../../../models/order.model';
import { OrderService } from '../../../../../../../services/order.service';
import { getDownPayment } from '../../../../utils/order-details.util';
import { getDownPaymentAttempts } from '../../../../utils/payment-attempts.util';
import { OrderInstallmentPaymentsDialogComponent } from '../order-installment-payments-dialog/order-installment-payments-dialog.component';

@Component({
  selector: 'app-order-down-payment',
  imports: [
    CurrencyPipe,
    DatePipe,
    TitleCasePipe,
    ButtonModule,
    TooltipModule,
    OrderInstallmentPaymentsDialogComponent,
  ],
  templateUrl: './order-down-payment.component.html',
})
export class OrderDownPaymentComponent {
  order = input<Order | null>(null);

  private orderService = inject(OrderService);

  downPayment = computed(() => getDownPayment(this.order()));

  latestPayment = computed(
    () => getDownPaymentAttempts(this.order())[0] ?? null,
  );

  hasPayments = computed(() => (this.downPayment()?.payments?.length ?? 0) > 0);

  paymentsDialogVisible = signal(false);

  getInstallmentStatusComponent(status: InstallmentStatus): string {
    return this.orderService.getInstallmentStatusComponent(status);
  }
}
